import {PewComponent} from "../../../../themes/wwp_child_theme/assets/raw/js/components/pew-component";

const masonry = require('masonry');

export default class NewsRoom extends PewComponent {

  init() {
    //this.recomputeIndexes();
    this.registerMasonry();
    this.registerPagination(this.element.find('.pagination'));
  }

  registerMasonry() {
    this.masonryInstance = this.element.find('.wall-blocks-grid').masonry({
      // options
      itemSelector: '.wall-blocks-grid > div',
    });
  }

  recomputeIndexes() {
    jQuery('.module-newsroom').each(function (i, instance) {
      $(instance).data('index', i);
    });
  }

  loadPage(href, cb) {
    var self = this;
    this.element.addClass('ajax-loading');
    $.get(href, {}, (res) => {
      this.element.removeClass('ajax-loading');
      var index = this.element.data('index');
      var $newContext = null;
      if (index) {
        $newContext = $($(res).find('.module-newsroom')[index]);
        $newContext.data('index', index);
      } else {
        $newContext = $(res).find('.module-newsroom').first();
      }

      const $newItems = $newContext.find('.wall-blocks-grid > *');
      this.element.find('.wall-blocks-grid')
        .append($newItems)
        .masonry('appended', $newItems);

      this.replacePagination($newContext.find('.pagination'));

      if (window.pew) {
        window.pew.enhanceRegistry(this.element.find('.wall-blocks-grid')[0]);
      }
      cb && cb();
    });
  }

  registerPagination($pagination) {
    $pagination.find('a.navlink').on('click', (e) => {
      e.preventDefault();
      $(e.currentTarget).replaceWith('<span class="loader loader--small"></span>');
      this.loadPage(e.currentTarget.href);
    })
  }

  replacePagination($newPagination) {
    this.element.find('.pagination').replaceWith($newPagination);
    this.registerPagination($newPagination);
  }

}

window.pew.addRegistryEntry({key: 'wwp-newsroom', classDef: NewsRoom, domSelector: '.module-newsroom'});
